<template src="./index.html"></template>

<script>
import { format } from 'date-fns'
import agTableComp from '@/optionData/agTableComp'


export default {
  name: 'exportPresetList',
  data() {
    return {
      keyword: '',
      total: 0,
      listData: [],
      deleteTarget: null,
      page: {
        pageSize: 20,
        currentPage: 1,
        totalPage: 0,
      },
      gridOptions: {
        context: { componentParent: this },
        frameworkComponents: { ...agTableComp },
        getRowHeight: () => 52,
        getRowStyle: (params) => {
          if (params.data && params.data.deleted_at) {
            return { opacity: '0.45', cursor: 'default' }
          }
          return { cursor: 'pointer' }
        },
        onCellClicked: (params) => {
          if (params.column.getColId() === 'actions') return
          if (params.data && !params.data.deleted_at) {
            this.$router.push({ path: `/export-preset/edit/${params.data.id}` })
          }
        },
      },
      defaultColDef: {
        sortable: false,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: '이름',
          field: 'name',
          width: 220,
          cellRenderer: (params) => {
            const deleted = params.data.deleted_at
            return `${params.value}${deleted ? ' <span style="color:#ea5455;font-size:11px;margin-left:4px;">[삭제됨]</span>' : ''}`
          },
        },
        {
          headerName: '코드',
          field: 'code',
          width: 230,
          cellRenderer: (params) => {
            const val = params.value || ''
            const safe = val.replace(/'/g, "\\'").replace(/"/g, '&quot;')
            const copyIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>`
            const checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#28C76F" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`
            return `<div
              style="display:flex;align-items:center;gap:8px;height:100%;"
              onmouseenter="this.querySelector('.ep-copy-btn').style.opacity='1'"
              onmouseleave="this.querySelector('.ep-copy-btn').style.opacity='0'"
            >
              <code style="background:#f0f0f0;padding:1px 7px;border-radius:3px;font-size:11px;font-family:monospace;line-height:1.5;display:inline-block;vertical-align:middle;">${val}</code>
              <button
                class="ep-copy-btn"
                data-copy="${safe}"
                data-copy-icon="${copyIcon.replace(/"/g, '&quot;')}"
                data-check-icon="${checkIcon.replace(/"/g, '&quot;')}"
                style="opacity:0;transition:opacity 0.15s;background:transparent;border:none;padding:2px;cursor:pointer;color:#888;display:flex;align-items:center;line-height:1;"
                onclick="event.stopPropagation();(function(btn){navigator.clipboard.writeText(btn.dataset.copy).then(function(){btn.innerHTML=btn.dataset.checkIcon;setTimeout(function(){btn.innerHTML=btn.dataset.copyIcon},1400)})})(this)"
              >${copyIcon}</button>
            </div>`
          },
        },
        {
          headerName: '계약사 수',
          field: 'export_contract_preset_export_contract',
          width: 90,
          cellRenderer: (params) => {
            const count = params.value ? params.value.length : 0
            return `<span style="font-weight:600;">${count}개</span>`
          },
        },
        {
          headerName: '메모',
          field: 'notes',
          width: 200,
          cellRenderer: (params) => params.value || '<span style="color:#999;">—</span>',
        },
        {
          headerName: '등록일',
          field: 'created_at',
          width: 110,
          cellRenderer: (params) => {
            if (!params.value) return '-'
            try { return format(new Date(params.value), 'yyyy-MM-dd') } catch (e) { return params.value }
          },
        },
        {
          headerName: '',
          field: 'id',
          colId: 'actions',
          width: 80,
          cellRendererSelector: (params) => ({
            component: 'textButton2',
            params: {
              ...params.data,
              text: '',
              text2: '<button style="background:transparent;border:1px solid #ea5455;color:#ea5455;padding:3px 10px;border-radius:4px;cursor:pointer;font-size:12px;line-height:1.5;" onmouseover="this.style.background=\'#ea5455\';this.style.color=\'#fff\'" onmouseout="this.style.background=\'transparent\';this.style.color=\'#ea5455\'">삭제</button>',
              clicked: () => {},
              clicked2: (data) => { this.openDeleteConfirm(data) },
            },
          }),
        },
      ],
    }
  },
  watch: {
    'page.currentPage'() {
      this.loadList()
    },
  },
  mounted() {
    this.loadList()
  },
  methods: {
    loadList() {
      const payload = {
        page: this.page.currentPage - 1,
        limit: this.page.pageSize,
        ...(this.keyword ? { keyword: this.keyword } : {}),
      }
      this.loadingShow()
      this.$store.dispatch('GET_EXPORT_CONTRACT_PRESET_LIST', payload)
        .then((result) => {
          this.loadingHide()
          const items = result.items || result || []
          const active = items.filter(i => !i.deleted_at)
          const deleted = items.filter(i => i.deleted_at)
          this.listData = [...active, ...deleted]
          const total = result.total !== undefined ? result.total : (result.filtered !== undefined ? result.filtered : items.length)
          this.total = total
          const remainder = total % this.page.pageSize > 0 ? 1 : 0
          this.page.totalPage = Math.floor(total / this.page.pageSize) + remainder
        })
        .catch((error) => {
          this.loadingHide()
          if (error.response && error.response.status === 401) {
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(() => this.$router.push('/login'))
          }
        })
    },
    list_search() {
      this.page.currentPage = 1
      this.loadList()
    },
    resetSearch() {
      this.keyword = ''
      this.page.currentPage = 1
      this.loadList()
    },
    openDeleteConfirm(data) {
      this.deleteTarget = data
      this.openModal('deleteConfirm')
    },
    confirmDelete() {
      if (!this.deleteTarget) return
      this.loadingShow()
      this.$store.dispatch('DELETE_EXPORT_CONTRACT_PRESET', { id: this.deleteTarget.id })
        .then(() => {
          this.loadingHide()
          this.closeModal('deleteConfirm')
          this.deleteTarget = null
          this.noti('삭제되었습니다.')
          this.loadList()
        })
        .catch((error) => {
          this.loadingHide()
          const msg = error.response && error.response.data ? error.response.data.message : '삭제 중 오류가 발생했습니다.'
          this.alert({ msg })
        })
    },
  },
}
</script>

<style scoped>
</style>
